/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { CosmosButton, CosmosText, EdsIcon, ResponsiveContainer, SectionContainer } from "@components/elements";
import { useMessages } from "@epic-mw/i18n";

import { css } from "@panda/css";
import { VStack } from "@panda/jsx";

interface Props {
	statusCode?: 404 | 500;
}

const styled = css({
	display: "flex",
	alignItems: "center",
	minHeight: "80vh",
	textAlign: "center",
	overflow: "hidden",
});

export const ErrorSection = ({ statusCode = 404 }: Props): React.JSX.Element => {
	const messages = useMessages();
	return (
		<div className={`error ${styled}`}>
			<SectionContainer>
				<ResponsiveContainer>
					<VStack gap="eds.dimension.32" className={css({ maxWidth: "500px", position: "relative" })}>
						<div
							className={css({
								"& svg": {
									position: "absolute",
									width: "300px!important",
									height: "300px!important",
									left: "20%",
									filter: "blur(100px)",
									opacity: "0.8",
									transform: "translateZ(0)",
								},
							})}
						>
							<EdsIcon icon="RobotXMarks" gradient="indigo" size="xl" />
						</div>
						<div
							className={css({
								"& svg": {
									width: "eds.dimension.96!important",
									height: "eds.dimension.96!important",
								},
							})}
						>
							<EdsIcon icon="RobotXMarks" gradient="purple" size="xl" />
						</div>
						<VStack gap="eds.dimension.24">
							<CosmosText variant="heading2XL">{messages[`epic.cosmos.error.${statusCode}.title`] || ""}</CosmosText>
							<CosmosText variant="paragraphLG">
								{messages[`epic.cosmos.error.${statusCode}.description`] || ""}
							</CosmosText>
						</VStack>
						<CosmosButton label={messages["epic.cosmos.error.button"] || ""} size="xl" />
					</VStack>
				</ResponsiveContainer>
			</SectionContainer>
		</div>
	);
};
